export const APP_PREFIX_PATH = "";
export const API_URL = "https://winkdic.com/2025/B2B/server";
export const APP_LOGO = "https://winkdic.com/2025/B2B/server/logo/logo.png";
export const IMAGE_PATH = "https://winkdic.com/2025/B2B/server/images/";


//   const DEFAULT_SOCKET_URL = "https://winkdic.com/2025/B2B/server"; // your prod host

// export const CHAT_SOCKET_URL =
//   import.meta.env.VITE_CHAT_SOCKET_URL ?? DEFAULT_SOCKET_URL;

//   const DEFAULT_SOCKET_URL =
//   import.meta.env.MODE === "development"
//     ? "ws://localhost:5000"
//     : "wss://winkdic.com"; // prod के लिए बाद में

export const CHAT_SOCKET_URL =
 "ws://localhost:3000";